var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgerDotMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00002 8.83337C2.46026 8.83337 2.83335 8.46028 2.83335 8.00004C2.83335 7.5398 2.46026 7.16671 2.00002 7.16671C1.53978 7.16671 1.16669 7.5398 1.16669 8.00004C1.16669 8.46028 1.53978 8.83337 2.00002 8.83337Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00002 3.00004C2.46026 3.00004 2.83335 2.62694 2.83335 2.16671C2.83335 1.70647 2.46026 1.33337 2.00002 1.33337C1.53978 1.33337 1.16669 1.70647 1.16669 2.16671C1.16669 2.62694 1.53978 3.00004 2.00002 3.00004Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00002 14.6667C2.46026 14.6667 2.83335 14.2936 2.83335 13.8334C2.83335 13.3731 2.46026 13 2.00002 13C1.53978 13 1.16669 13.3731 1.16669 13.8334C1.16669 14.2936 1.53978 14.6667 2.00002 14.6667Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerDotMenu);
export default __webpack_public_path__ + "static/media/hamburgerDotMenu.8dcb4fdaf3ef6e5d99832b823df4b12e.svg";
export { ForwardRef as ReactComponent };